import session from "../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../services/api";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            oldPassword:'',
            newPassword:'',
            repeatPassword:''
        }
    },
    methods: {
        resetPassword: resetPassword
    },
    beforeMount() {
        if(session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }

    }
}

function resetPassword() {
    if(this.newPassword.trim() === ''){
        swal(LocService.t('label_error'), LocService.t('label_password_error_not_empty'), 'error');
        return;
    }

    if(this.oldPassword.trim() === ''){
        swal(LocService.t('label_error'), LocService.t('label_password_error_old_password_not_empty'), 'error');
        return;
    }

    if(this.newPassword !== this.repeatPassword){
        swal(LocService.t('label_error'), LocService.t('label_password_error_repeat_same_password'), 'error');
        return;
    }

    let model = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
    }

    AdminApiService.resetPassword(model)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_password_success_changed'), 'success')
            this.$router.back()
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Account/ResetPassword.js